import { supabase } from '@/integrations/supabase/client';

/**
 * Fire-and-forget: notify game members about a birdie/eagle/albatross.
 * Never throws — errors are silently logged.
 */
export const notifyBirdieRecorded = (params: {
  scoreId: string;
  scorerId: string;
  scoreType: 'birdie' | 'eagle' | 'double_eagle';
  holeNumber: number;
  courseId: string;
  gameIds: string[];
  isManualPlayer?: boolean;
  manualPlayerName?: string;
}) => {
  supabase.functions
    .invoke('send-birdie-notification', { body: params })
    .catch((err) => console.error('notifyBirdieRecorded failed:', err));
};

/**
 * Fire-and-forget: send an invite or friend-request notification email.
 * Never throws — errors are silently logged.
 */
export const notifyFriendInvite = async (params: {
  type: 'new_user' | 'manual_player' | 'friend_request';
  recipientEmail: string;
  recipientName?: string;
}) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    supabase.functions
      .invoke('send-invite-email', {
        body: { ...params, inviterId: user.id },
      })
      .catch((err) => console.error('notifyFriendInvite failed:', err));
  } catch (err) {
    console.error('notifyFriendInvite failed:', err);
  }
};
